import { render } from "./CheckoutPayment.vue?vue&type=template&id=3123bd26"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__